// True if EVERY entry in anyEntries list is included in baseList
export function includesAll<T>(baseList: T[], ...requiredEntries: T[]): boolean {
  return requiredEntries.every(entry => baseList.includes(entry))
}

// True if one or more of the anyEntries list is included in baseList
export function includesSome<T>(baseList: T[], ...anyEntries: T[]): boolean {
  return anyEntries.some(entry => baseList.includes(entry))
}

// True if ALL entries of baseList match the pattern
export function matchesAll<T extends string>(baseList: T[], pattern: string | RegExp): boolean {
  const regex = new RegExp(pattern)
  return baseList.every(entry => regex.test(entry))
}

// True if one or more entries of baseList match the pattern
export function matchesSome<T extends string>(baseList: T[], pattern: string | RegExp): boolean {
  const regex = new RegExp(pattern)
  return baseList.some(entry => regex.test(entry))
}
